/* eslint-disable no-bitwise */

// Note: using fast-base64-decode's base64 decoder here
var lookup = [
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 62, 0, 62, 0, 63, 52, 53,
  54, 55, 56, 57, 58, 59, 60, 61, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7,
  8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 0, 0, 0,
  0, 63, 0, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
  43, 44, 45, 46, 47, 48, 49, 50, 51,
];
const base64Decode = (source: string, target: Uint8Array) => {
  var sourceLength = source.length;
  var paddingLength =
    source[sourceLength - 2] === '='
      ? 2
      : source[sourceLength - 1] === '='
      ? 1
      : 0;

  var tmp;
  var byteIndex = 0;
  var baseLength = (sourceLength - paddingLength) & 0xfffffffc;

  for (var i = 0; i < baseLength; i += 4) {
    tmp =
      (lookup[source.charCodeAt(i)] << 18) |
      (lookup[source.charCodeAt(i + 1)] << 12) |
      (lookup[source.charCodeAt(i + 2)] << 6) |
      lookup[source.charCodeAt(i + 3)];

    target[byteIndex++] = (tmp >> 16) & 0xff;
    target[byteIndex++] = (tmp >> 8) & 0xff;
    target[byteIndex++] = tmp & 0xff;
  }

  if (paddingLength === 1) {
    tmp =
      (lookup[source.charCodeAt(i)] << 10) |
      (lookup[source.charCodeAt(i + 1)] << 4) |
      (lookup[source.charCodeAt(i + 2)] >> 2);

    target[byteIndex++] = (tmp >> 8) & 0xff;
    target[byteIndex++] = tmp & 0xff;
  }

  if (paddingLength === 2) {
    tmp =
      (lookup[source.charCodeAt(i)] << 2) |
      (lookup[source.charCodeAt(i + 1)] >> 4);

    target[byteIndex++] = tmp & 0xff;
  }
};

const { NativeModules } = require('react-native');

class TypeMismatchError extends Error {}
class QuotaExceededError extends Error {}

let warned = false;
function insecureRandomValues(array) {
  if (!warned) {
    console.warn(
      'Using an insecure random number generator, this should only happen when running in a debugger without support for crypto.getRandomValues'
    );
    warned = true;
  }

  for (let i = 0, r; i < array.length; i++) {
    if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
    array[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
  }

  return array;
}

/**
 * @param {number} byteLength
 * @returns {string}
 */
function getRandomBase64(byteLength) {
  if (NativeModules.Core) {
    return NativeModules.Core.getRandomBase64(byteLength);
  } else if (NativeModules.ExpoRandom) {
    // Expo SDK 41-44
    return NativeModules.ExpoRandom.getRandomBase64String(byteLength);
  } else if (global.ExpoModules) {
    // Expo SDK 45+
    return global.ExpoModules.ExpoRandom.getRandomBase64String(byteLength);
  } else {
    throw new Error('Native module not found');
  }
}

/**
 * @param {Int8Array|Uint8Array|Int16Array|Uint16Array|Int32Array|Uint32Array|Uint8ClampedArray} array
 */
function getRandomValues(array) {
  if (
    !(
      array instanceof Int8Array ||
      array instanceof Uint8Array ||
      array instanceof Int16Array ||
      array instanceof Uint16Array ||
      array instanceof Int32Array ||
      array instanceof Uint32Array ||
      array instanceof Uint8ClampedArray
    )
  ) {
    throw new TypeMismatchError('Expected an integer array');
  }

  if (array.byteLength > 65536) {
    throw new QuotaExceededError('Can only request a maximum of 65536 bytes');
  }

  // Expo SDK 48+
  if (
    global.expo &&
    global.expo.modules &&
    global.expo.modules.ExpoCrypto &&
    global.expo.modules.ExpoCrypto.getRandomValues
  ) {
    // ExpoCrypto.getRandomValues doesn't return the array
    global.expo.modules.ExpoCrypto.getRandomValues(array);
    return array;
  }

  // Calling getRandomBase64 in debug mode leads to the error
  // "Calling synchronous methods on native modules is not supported in Chrome".
  // So in that specific case we fall back to just using Math.random.
  if (__DEV__) {
    if (typeof global.nativeCallSyncHook === 'undefined') {
      return insecureRandomValues(array);
    }
  }

  base64Decode(
    getRandomBase64(array.byteLength),
    new Uint8Array(array.buffer, array.byteOffset, array.byteLength)
  );

  return array;
}

if (typeof global.crypto !== 'object') {
  // @ts-ignore
  global.crypto = {};
}

if (typeof global.crypto.getRandomValues !== 'function') {
  global.crypto.getRandomValues = getRandomValues;
}
